import { Box, Tooltip as MuiTooltip, IconButton } from '@mui/material';
import { QuestionMarkCircleIcon } from '../../assets/icons/icons';

const Tooltip = ({ title, size = 14 }) => {
  return (
    <Box component="span" onClick={(e) => e.preventDefault()}>
      <MuiTooltip title={title} enterTouchDelay={0} leaveTouchDelay={Infinity}>
        <IconButton>
          <QuestionMarkCircleIcon size={size} />
        </IconButton>
      </MuiTooltip>
    </Box>
  );
};

export default Tooltip;
